import { useSelector } from 'react-redux';
import { selectUser } from '../redux/features/user';

export const useUser = () => {
    const user = useSelector(selectUser);
    return user;
};